import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/experience_comment_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  content_cont: {
    model_name: 'ExperienceComment',
    column_type: 'string',
    column_name: 'content',
  },
  deleted_at_not_null: {
    column_type: 'boolean',
    model_name: 'ExperienceComment',
    column_name: 'deletedAt',
  },
  position_not_null: {
    column_type: 'boolean',
    model_name: 'ExperienceComment',
    column_name: 'position',
  },
  commentable_of_Post_type_type_eq: {
    column_type: 'type',
    extra: {
      options: [],
    },
    model_name: 'Post',
    column_name: 'type',
  },
  commentable_id_eq: {
    model_name: 'ExperienceComment',
    column_type: 'string',
    column_name: 'commentableId',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return entityColumnsExtend(shareColumnsExtend('ExperienceComment', columns), { filterColumnsExtend })
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('ExperienceComment', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
